"use client";
import Image from "next/image";

export default function AboutUs() {
    return (
        <section className="relative h-[500px]  flex items-center justify-center overflow-hidden">
            <Image
                src="https://res.cloudinary.com/kab/image/upload/v1786450175/KarnatakaAgribusiness_uglcrf.png"
                alt="About us background"
                fill
                className="absolute inset-0 object-fit"
                priority
                fetchPriority="high"
            />

            {/* Gradient Overlay for better text readability */}
            {/* <div className="absolute inset-0 bg-linear-to-b from-black/50 via-black/40 to-black/60" /> */}

            {/* Content Container */}
            {/* <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-8 lg:px-12 text-center">
                <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white tracking-tight leading-tight mb-6">
                    Who We Are
                </h1>

                <p className="text-lg text-white/90 font-light max-w-3xl mx-auto leading-relaxed">
                    Discover our story, mission, and the passion that drives us forward
                </p>
            </div> */}
        </section>
    );
}
